'use strict';
define(function () {

    var MS_USER_COOKIE = 'MS_USER_COOKIE',
        config = window.mnsHeaderConfig ? window.mnsHeaderConfig : {};

    /**
     * Returns logged in user status from MS_USER_COOKIE
     * @returns {boolean} TRUE if user is logged in
     */
    function isUserLoggedIn() {
        return getUserCookieValue() !== null;
    }

    /**
     * Returns username from MS_USER_COOKIE
     * @returns {string | null} username
     */
    function getUsername() {
        var value = getUserCookieValue();

        return value !== null ? value.split('_')[0] : null;
    }

    function getStoreIdSuffixCookieValue(patternStr) {
        var cookieKey,
            cookieVal,
            cookiePattern = patternStr + '=',
            storeAwareCookiePattern;

        if (config.MS_MAKE_STORE_AWARE_COOKIE) {
            // read store aware cookie
            storeAwareCookiePattern = patternStr + '_'  + config.storeId + '=';
            cookieVal = getCookieValue(storeAwareCookiePattern);

            if (cookieVal) {
                return cookieVal;
            }

            // read existing cookie
            cookieVal = getCookieValue(cookiePattern);

            if (cookieVal) {
                cookieKey = getCookieKey(cookiePattern);
                setCookieWithOptions((cookieKey + '_' + config.storeId), cookieVal);
            }

            return cookieVal;
        }

        return getCookieValue(cookiePattern);
    }

    function setCookieWithOptions(key, value, options, raw, json) {
        options = options ? options : {};
        raw = raw ? raw : false;
        json = json ? json : false;

        if (typeof options.expires === 'number') {
            const days = options.expires;
            const date = new Date();
            date.setDate(date.getDate() + days);
            options.expires = date.toUTCString();
        }

        value = json ? JSON.stringify(value) : String(value);
        value = raw ? value : encodeURIComponent(value);
        const keyValue = `${encodeURIComponent(key)}=${value};`;

        const optionsString = Object.keys(options)
            .map(option => {
                if (option === 'Secure') {
                    return option;
                }
                return `${option}=${options[option]}`;
            })
            .join(';');

        return document.cookie = `${keyValue} ${optionsString}`;
    }

    function getCookieKey(patternStr) {
        var pattern = new RegExp(patternStr + '[^;]+'),
            matches = document.cookie.match(pattern);
        return matches && matches[0] ? matches[0].split('=')[0] :null;
    }

    function getCookieValue(patternStr) {
        var pattern = new RegExp(patternStr + '[^;]+'),
            matches = document.cookie.match(pattern);

        return matches && matches[0] ? matches[0].split('=')[1] : null;
    }

    function getUserCookieValue() {
        return getStoreIdSuffixCookieValue(MS_USER_COOKIE);
    }


    // service API
    return {
        isUserLoggedIn: isUserLoggedIn,
        getUsername: getUsername,
        getCookieValue: getCookieValue,
        getUserLoginCookieValue: getUserCookieValue
    };
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/cookieService.js
 **/